import type { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';

const Root = styled(ButtonBase)`
  position: relative;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: var(--unit);
`;

const Visual = styled.div`
  position: relative;
  display: flex;
`;

const ChipSlot = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: max-content;
`;

type Props = ComponentProps<typeof ButtonBase> & {
  chip?: ReactNode;
};

export const WidgetButton = ({ chip, children, ...props }: Props) => (
  <Root {...props}>
    <Visual>{children}</Visual>
    {!!chip && <ChipSlot>{chip}</ChipSlot>}
  </Root>
);
